export default {
  apiKey: "AIzaSyCRlXIQ2jWNrJu4hldhz6JwVKs-wofC46E",
  authDomain: "dodo-40542.firebaseapp.com",
  databaseURL: "https://dodo-40542.firebaseio.com",
  projectId: "dodo-40542",
  storageBucket: "dodo-40542.firebasestorage.app",
  messagingSenderId: "797871797286",
  appId: "1:797871797286:web:bbbe8b1de1e5dc3ceb62e7"
}
